import imgHeader from "../../assets/img/page-header.webp";
import { Link } from "react-router-dom";


const Contact = () => {
  return (
    <>
      {/* Header Section */}
      <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
        <img
          src={imgHeader}
          alt="Encabezado de página curso online"
          className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
          style={{ zIndex: 0 }}
          loading="eager"
          decoding="async"
        />

        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

        <div className="container position-relative" style={{ zIndex: 2 }}>
          <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
            <h3 className="display-4 text-white text-uppercase">Contacto</h3>
            <div className="d-inline-flex text-white">
              <p className="m-0 text-uppercase">
                <Link to="/">Inicio</Link>
              </p>
              <i className="fa fa-angle-double-right pt-1 px-3"></i>
              <p className="m-0 text-uppercase">Contacto</p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form */}
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div className="text-center mb-5">
            <h5 className="text-primary text-uppercase mb-3" style={{ letterSpacing: "5px" }}>
              Contacto
            </h5>
            <h1>Contáctenos para cualquier consulta</h1>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="contact-form bg-secondary rounded p-5">
                <form name="sentMessage" id="contactForm" noValidate>
                  <div className="control-group mb-4">
                    <input
                      type="text"
                      className="form-control border-0 p-4"
                      id="name"
                      placeholder="Nombre completo"
                      required
                    />
                  </div>
                  <div className="control-group mb-4">
                    <input
                      type="email"
                      className="form-control border-0 p-4"
                      id="email"
                      placeholder="Correo electrónico"
                      required
                    />
                  </div>
                  <div className="control-group mb-4">
                    <input
                      type="text"
                      className="form-control border-0 p-4"
                      id="subject"
                      placeholder="Asunto"
                      required
                    />
                  </div>
                  <div className="control-group mb-4">
                    <textarea
                      className="form-control border-0 py-3 px-4"
                      rows="5"
                      id="message"
                      placeholder="Mensaje"
                      required
                    ></textarea>
                  </div>
                  <div className="text-center">
                    <button
                      className="btn btn-primary py-3 px-5"
                      type="submit"
                      id="sendMessageButton"
                    >
                      Enviar mensaje
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
